module.exports = __webpack_public_path__ + "assets/img/block-left-5cc7a534.png";